export default __webpack_public_path__ + "static/media/empty-general.8f053c53.svg";